import { URI } from '@/config/config';

export default async ({ rootState }, payload) => {
  const url = new URL(`${URI}control-panel/employee/logged-monitor`);

  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };
  let baseURL = url;

  const query = Object.keys(payload)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
    .join('&');

  baseURL += `?${query}`;

  const userLoginInfoResult = await fetch(baseURL, opts);
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult.list;
};
